
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BarraProgresso',
  props: {
    visivel: {
      type: Boolean,
      required: true,
    },
    frase: {
      type: String,
      default: 'Aguarde por favor...',
    },
  },
  setup(props) {
    return {
      props,
    };
  },
});
